export default "__VITE_ASSET__aoYwcsNo__"